import { Component, Input, EventEmitter, Output, ViewChild, HostListener } from '@angular/core';

import { UploadModalComponent } from '../notes';

@Component({
  selector: 'app-drop-area',
  templateUrl: './drop-area.component.html',
})
export class DropAreaComponent {
  errors: string[];

  @Input() maxSize = 10;
  @Output() attachments = new EventEmitter();
  @ViewChild(UploadModalComponent) private uploadModal;

  upload(fileList: FileList) {
    const files = Array.from(fileList);
    this.errors = null;

    // Ensure files aess than 10mb
    if (files.some(file => file.size > (this.maxSize * 1048576))) {
      this.errors = [`Documents may not be greater than ${this.maxSize}MB.`];
      return;
    }

    // Ensure we have uploaded files
    if (! files.length) {
      return;
    }

    this.uploadModal.open(files);
  }

  @HostListener('window:dragover', ["$event"])
  onDragOver() {
    return false;
  }

  @HostListener('window:drop', ["$event"])
  onDrop(event) {
    event.preventDefault();
    this.upload(event.dataTransfer.files);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/attachments/drop-area.component.ts